import { Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../environments/environment';
import { StateService } from '../../services/state.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule, MatProgressSpinnerModule]
})

export class LoginComponent implements OnInit {
    isLoggedIn: boolean | undefined;
    guid: string | undefined;
    isFirstSignIn: boolean | undefined;
    
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private stateService: StateService,
        private authService: MsalService
    ) {
        this.stateService.$loginDisplay.subscribe(isLoggedIn => {
            this.isLoggedIn = isLoggedIn;
        });

        this.stateService.$isFirstSignIn.subscribe(isFirstSignIn => {
            this.isFirstSignIn = isFirstSignIn;
        });
    }

    ngOnInit(): void {
        const snapshot: ActivatedRouteSnapshot = this.route.snapshot;
        this.guid = snapshot.params['guid']?.toUpperCase();

        if (this.isDefaultGuid) {
            this.setSigningUpFlag(false);
            this.router.navigate([`/landing`]);
        } 
        else {
            if (this.isLoggedIn) {
                const claimRef = this.stateService.claimRef;

                if (claimRef) {
                    this.router.navigate([`/home/${claimRef}`]);
                } 
                else {
                    this.router.navigate(['/error'], {
                        queryParams: {
                            headerText: 'Error - Missing Claim Reference',
                            contentText: 'We could not find a claim reference associated with your account. Please contact support for assistance.'
                        }
                    });
                }
            } 
            else {
                this.setSigningUpFlag(true);
                this.redirectToExternalLogin();
            }
        }
    }

    private redirectToExternalLogin = () => {
        if (this.isFirstSignIn) { 
            this.authService.loginRedirect({
                authority: environment.msalConfig.auth.noMfaAuthority,
                scopes: [...environment.apiConfig.scopes]
            });
        } else {
            this.authService.loginRedirect({
                authority: environment.msalConfig.auth.authority,
                scopes: [...environment.apiConfig.scopes]
            });
        }
    };

    get isDefaultGuid(): boolean {
        return this.guid === environment.defaultGuid;
    }

    private setSigningUpFlag(isSigningUp: boolean) {
        this.stateService.isSigningUp = isSigningUp;
        localStorage.setItem('signingUp', JSON.stringify(isSigningUp));
    }
}
